import 'zone.js';

export class NemRootZone extends (Zone as any) {}
